module.exports = __webpack_public_path__ + "static/img/bottom_img.4185a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/bottom_img.png
// module id = 4BPq
// module chunks = 4